import api from '@/api/index.js'

const emv_clearings = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_EMV_CLEARINGS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_EMV_CLEARINGS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_EMV_CLEARINGS_UPDATED: (state, u) => {
      state.data = state.data.filter(item => {
        if (item.id == u.id) {
          Object.assign(item, u);
        }
        return item
      });
    },
    SET_EMV_CLEARINGS_ERROR: (state, error) => {
      state.error = error
    },
    SET_EMV_CLEARINGS_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadEmvClearings({commit}, query) {
      commit('SET_EMV_CLEARINGS', [])
      commit('SET_EMV_CLEARINGS_ERROR', null)
      commit('SET_EMV_CLEARINGS_LOADING', true)
      return api.get(`emv-clearings?limit=300&offset=0&payment-results=${query.paymentResults}&payment-reference=${query.paymentReference}&clearing-id=${query.clearingId}&`)
        .then((response) => {
          commit('SET_EMV_CLEARINGS', response)
        })
        .catch((error) => {
          commit('SET_EMV_CLEARINGS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_CLEARINGS_LOADING', false)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  }
}

export default emv_clearings
